import { Label } from './label'
import { ValidationError } from './validation-error'
import { FieldError } from 'react-hook-form'
import { memo } from 'react'

export const FieldBlock = memo(
  ({
    children,
    htmlFor,
    labelText,
    required,
    error,
  }: {
    children: React.ReactNode
    labelText: string
    htmlFor: string
    required?: boolean
    error?: FieldError
  }) => {
    const inputClass = error ? 'error_input' : 'done_input'
    return (
      <div className={`relative ${inputClass}`}>
        <Label labelText={labelText} htmlFor={htmlFor} required={required} />
        {children}
        <ValidationError error={error} />
      </div>
    )
  }
)

FieldBlock.displayName = 'FieldBlock'
